import React from "react";
import { View } from "react-native";
import { AHThemeType, CircleSize, useCircleSize, useTheme, AHIcon, AHIconType } from "arkh";
import { EmptyResult } from "./EmptyResults";

type Sentiment = "POSITIVE" | "NEGATIVE" | "NEUTRAL";

type OptionProps = {
  sentiment?: Sentiment | null;
  size: CircleSize;
};

const getIconName = (sentiment: Sentiment): AHIconType => {
  switch (sentiment) {
    case "POSITIVE":
      return "check";
    case "NEGATIVE":
      return "clear";
    case "NEUTRAL":
    default:
      return "check";
  }
};

const getColor = (sentiment: Sentiment, theme: AHThemeType) => {
  switch (sentiment) {
    case "POSITIVE":
      return theme.positive;
    case "NEGATIVE":
      return theme.negative;
    case "NEUTRAL":
    default:
      return "black";
  }
};

export const TaskOptionsOption = ({ sentiment, size }: OptionProps) => {
  const theme = useTheme();
  const scaledSize = useCircleSize(size);
  return (
    <>
      {sentiment ? (
        <View
          style={{
            borderRadius: Math.ceil(scaledSize / 2),
            width: scaledSize,
            height: scaledSize,
            borderColor: getColor(sentiment, theme),
            backgroundColor: getColor(sentiment, theme),
            borderWidth: 2,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <AHIcon
            type={getIconName(sentiment)}
            customColor={theme.lightText}
            forceSize={scaledSize / 2}
          />
        </View>
      ) : (
        <View
          style={{
            width: scaledSize,
            height: scaledSize,
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <EmptyResult absoluteSize={scaledSize} />
        </View>
      )}
    </>
  );
};
